module.exports = __webpack_public_path__ + "src/img/loading-g.2befa2aa.svg";